import React, { FC, FormEvent, memo, useCallback, useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router';

import Form, { Item, RangeRule, RequiredRule } from 'devextreme-react/form';
import { DropDownOptions } from 'devextreme-react/select-box';
//devextreem
import { TextBox } from 'devextreme-react/text-box';
import ValidationGroup from 'devextreme-react/validation-group';
import Validator from 'devextreme-react/validator';

import { Button, DateBox, NumberBox, SelectBox, TextArea } from 'devextreme-react';
import DataSource from 'devextreme/data/data_source';

import { Status } from '..';
import '../../..';
import { ComingNomenclatureMain } from '../../../../../../../bus/comingNomenclatureMain/types';
import { AppCol, AppGroup, AppRow } from '../../../../../../../components/appComponents';
import { AppFieldBox } from '../../../../../../../components/appComponents';
import ClaimsProvider from '../../../../../../../components/claimsBlock';
import $createDataSource from '../../../../../../../utils/create-data-souce-instance';

type DetailModalRoleProps = {
  comingNomenclature: ComingNomenclatureMain | null;
  handleSubmit: (value: ComingNomenclatureMain) => void;
  contractorDataStore: DataSource;
  materialDataSource: DataSource;
  unitDataSource: Array<{ id: number; name: string }> | undefined;
  factoryDataStore: DataSource;
  loading: boolean;
  onChangeMaterial: (id: number) => void;
};

const FormCompoent: FC<DetailModalRoleProps> = ({
  comingNomenclature,
  handleSubmit,
  onChangeMaterial,
  contractorDataStore,
  materialDataSource,
  unitDataSource,
  factoryDataStore,
  loading,
}) => {
  const { id } = useParams<{ id: string }>();
  let createFacroryGroupValidationRef = useRef<ValidationGroup>(null);

  const [form, setForm] = useState<ComingNomenclatureMain>(comingNomenclature!);
  const [carierItems, setCarierItems] = useState([]);

  const storeContractorObject = useCallback((contractorId: number) => {
    const defaultFilter = ['type', '=', 0];
    return $createDataSource(`/v1/ContractorObject/${contractorId}`, 'id', {
      pageSize: 20,
      paginate: true,
      defaultFilter,
    });
  }, []);

  useEffect(() => {
    if (form.contractorId)
      storeContractorObject(form.contractorId)
        .load()
        .then((res: any) => setCarierItems(res));
  }, [form.contractorId, storeContractorObject]);

  const onSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault && event.preventDefault();
    if (createFacroryGroupValidationRef.current?.instance.validate().isValid) {
      handleSubmit(form);
    }
  };

  useEffect(() => {
    setForm(comingNomenclature!);
  }, [comingNomenclature]);

  return (
    <AppRow>
      <AppCol col={8}>
        <form onSubmit={onSubmit}>
          <ValidationGroup ref={createFacroryGroupValidationRef}>
            <Form id="test-facrory" formData={form}>
              <Item colSpan={12} colCount={12} itemType="group">
                <AppRow>
                  <AppGroup col={12}>
                    <ClaimsProvider claimsBlock={['ComingFactorySelectRequired']}>
                      <AppFieldBox label="Завод" labelTop>
                        <SelectBox
                          stylingMode="underlined"
                          dataSource={factoryDataStore}
                          displayExpr="name"
                          valueExpr="id"
                          value={form.factoryId}
                          onItemClick={(e) => {
                            setForm((prev) => ({ ...prev, factoryId: e.itemData.id }));
                          }}
                        >
                          <DropDownOptions title="Выберите Завод" closeOnOutsideClick={true} showTitle={false} />
                          <Validator>
                            <RequiredRule message="Выберите Завод" />
                          </Validator>
                        </SelectBox>
                      </AppFieldBox>
                    </ClaimsProvider>

                    <AppFieldBox label="Дата" labelTop>
                      <DateBox
                        stylingMode="underlined"
                        type="date"
                        onValueChange={(e) => {
                          setForm((prev) => ({ ...prev, date: e as string }));
                        }}
                        useMaskBehavior
                        dateSerializationFormat="yyyy-MM-ddTHH:mm:ssx"
                        value={form.date}
                      >
                        <Validator>
                          <RequiredRule message="Заполните поле дата" />
                        </Validator>
                      </DateBox>
                    </AppFieldBox>

                    <AppFieldBox label="Контрагент" labelTop>
                      <SelectBox
                        stylingMode="underlined"
                        placeholder=""
                        searchEnabled
                        value={form.contractorId}
                        onItemClick={(e) => {
                          setForm((prev) => ({ ...prev, contractorId: e.itemData.id, objectId: null }));
                          //getContractorObject(e.itemData.id);
                        }}
                        displayExpr="name"
                        valueExpr="id"
                        dataSource={contractorDataStore}
                      ></SelectBox>
                    </AppFieldBox>

                    <AppFieldBox label="Карьер" labelTop>
                      <SelectBox
                        stylingMode="underlined"
                        items={carierItems}
                        displayExpr="address"
                        valueExpr="id"
                        value={form.objectId}
                        searchEnabled
                        onItemClick={(e) => {
                          setForm((prev) => ({ ...prev, objectId: e.itemData.id }));
                        }}
                      >
                        <DropDownOptions title="Выберите Карьер" closeOnOutsideClick={true} showTitle={false} />
                        <Validator>
                          <RequiredRule message="Выберите объект" />
                        </Validator>
                      </SelectBox>
                    </AppFieldBox>
                    <AppRow>
                      <AppCol col={6}>
                        <AppFieldBox label="Материал" labelTop>
                          <div className="d-flex align-center">
                            <SelectBox
                              stylingMode="underlined"
                              style={{ width: '100%' }}
                              dataSource={materialDataSource}
                              displayExpr="name"
                              valueExpr="id"
                              value={form.nomenclatureId}
                              onValueChange={(e) => {
                                setForm((prev) => ({ ...prev, nomenclatureId: e }));
                                onChangeMaterial(e);
                              }}
                            >
                              <DropDownOptions title="Выберите марку" closeOnOutsideClick={true} showTitle={false} />
                              <Validator>
                                <RequiredRule message="Выберите марку" />
                              </Validator>
                            </SelectBox>
                          </div>
                        </AppFieldBox>
                      </AppCol>
                      <AppCol col={6}>
                        <AppFieldBox label="Материал по документам" labelTop>
                          <TextBox
                            stylingMode="underlined"
                            placeholder=""
                            mode="text"
                            value={form.nomenclatureAnotation}
                            onValueChange={(e: any) => {
                              setForm((prev) => ({ ...prev, nomenclatureAnotation: e }));
                            }}
                          ></TextBox>
                        </AppFieldBox>
                      </AppCol>
                    </AppRow>
                    <AppRow>
                      <AppCol col={6}>
                        <AppFieldBox label="Ед. изм." labelTop>
                          <div className="d-flex align-center">
                            <SelectBox
                              stylingMode="underlined"
                              style={{ width: '100%' }}
                              dataSource={unitDataSource}
                              displayExpr="name"
                              valueExpr="id"
                              value={form.unitId}
                              onValueChange={(e) => {
                                setForm((prev) => ({ ...prev, unitId: e }));
                              }}
                            >
                              <DropDownOptions title="Выберите Ед. изм." closeOnOutsideClick={true} showTitle={false} />
                              <Validator>
                                <RequiredRule message="Выберите Ед. изм." />
                              </Validator>
                            </SelectBox>
                          </div>
                        </AppFieldBox>
                      </AppCol>
                      <AppCol col={3}>
                        <AppFieldBox label="Стоимость" labelTop>
                          <NumberBox
                            stylingMode="underlined"
                            placeholder="0"
                            format="###0.##"
                            value={form.price}
                            onValueChanged={(e) => {
                              setForm((prev) => ({ ...prev, price: e.value }));
                            }}
                          >
                            <Validator>
                              <RequiredRule message="Заполните поле Стоимость" />
                            </Validator>
                          </NumberBox>
                        </AppFieldBox>
                      </AppCol>
                      <AppCol col={3}>
                        <AppFieldBox label="Цена рейса" labelTop>
                          <NumberBox
                            stylingMode="underlined"
                            placeholder="0"
                            format="###0.##"
                            value={form.tonalSalary}
                            onValueChanged={(e) => {
                              setForm((prev) => ({ ...prev, tonalSalary: e.value }));
                            }}
                          />
                        </AppFieldBox>
                      </AppCol>
                    </AppRow>
                    <AppFieldBox label="Комментарий" labelTop>
                      <TextArea
                        stylingMode="underlined"
                        placeholder="Введите комментарий"
                        mode="text"
                        value={form.comment || ''}
                        onChange={(e: any) => {
                          setForm((prev) => ({ ...prev, comment: e.event.currentTarget.value }));
                        }}
                      />
                    </AppFieldBox>
                  </AppGroup>
                </AppRow>
                <div className="d-flex justify-end mt-1">
                  <Button
                    text="Сохранить"
                    type="success"
                    useSubmitBehavior={false}
                    //@ts-ignore
                    onClick={onSubmit}
                    disabled={loading}
                  />
                </div>
              </Item>
            </Form>
          </ValidationGroup>
        </form>
      </AppCol>
      <AppCol col={4}>
        <ClaimsProvider claimsBlock={['CanChangeComingMaterialStatus']}>
          {id && <Status readOnly={false} value={form.status} />}
        </ClaimsProvider>
      </AppCol>
    </AppRow>
  );
};

export default memo(FormCompoent);
